module.exports = __webpack_public_path__ + "static/media/house.6ddb3840.jpeg";